import MenuDropdown from '../Buttons/MenuDropdown'

interface FilterHeaderProps {
  title: string
  filterEnabled?: boolean
  options?: string[]
  selectedFilter?: string
  setSelectedFilter?: (filter: string) => void
}
const FilterHeader: React.FC<FilterHeaderProps> = ({
  title,
  filterEnabled = false,
  options,
  selectedFilter,
  setSelectedFilter,
}) =>
  filterEnabled && options && selectedFilter && setSelectedFilter ? (
    <MenuDropdown
      options={options}
      title={title}
      filterHeader
      fixedOrder
      selectedOption={selectedFilter}
      setSelectedOptions={setSelectedFilter}
    />
  ) : (
    <>{title}</>
  )

export default FilterHeader
